document.addEventListener('DOMContentLoaded', function () {
  var hamburger = document.querySelector('.menu__hamburger');
  var menuMobile = document.querySelector('.menu-mobile');

  hamburger.addEventListener('click', function () {
    menuMobile.classList.toggle('fade-in-menu');
    hamburger.classList.toggle('hidden');

    if (menuMobile.classList.contains('fade-in-menu')) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
  });

  document.addEventListener('click', function (e) {
    if (!menuMobile.contains(e.target) && !hamburger.contains(e.target)) {
      menuMobile.classList.remove('fade-in-menu');
      hamburger.classList.remove('hidden');
      document.body.style.overflow = '';
    }
  });

  function handleResize() {
    if (window.innerWidth > 1200) {
      menuMobile.classList.remove('fade-in-menu');
      hamburger.classList.remove('hidden');
      document.body.style.overflow = '';
    }
  }

  window.addEventListener('resize', handleResize);
  handleResize();

  function handleClick() {
    var menu = document.querySelector('.menu-mobile');
    var hamburger = document.querySelector('.menu__hamburger');
    menu.classList.remove('fade-in-menu');
    hamburger.classList.remove('hidden');
  }

  document.querySelectorAll('.menu-mobile li a').forEach(function(link) {
      link.addEventListener('click', handleClick);
  });

  document.querySelector('.sample-button-mobile').addEventListener('click', handleClick);

});